<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © Intelliassist.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-right d-none d-sm-block">
                    
                </div>
            </div>
        </div>
    </div>
</footer>